export default "__VITE_ASSET__C3502G5v__"